// extracted by mini-css-extract-plugin
module.exports = {"budgetSettings":"src-components-BudgetBuilder-Overview-Main-styles___budgetSettings"};